import { lazy, Suspense, useEffect, useState } from "react";
import "tailwindcss/dist/base.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "styles/globalStyles.css";
import { HelmetProvider } from 'react-helmet-async';
import logo from "images/recent_logo.png";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useCartContext } from "context/UseCartContext.js";
import  QRCode  from './pages/QRCode.js';
import Header from "./components/headers/header.js";
import Footer from "./components/footers/footer.js";
import { login } from "./api/LoginApi.js";
import {
  getHeaderConfig,
  setBearerToken,
  setBranchId,
} from "./utility/HeaderConfig.js";
import { branchdetails } from "api/BranchDetailsApi";
import { getBranchId, setCorporateId } from "utility/HeaderConfig";
import ScrollToTop from "utility/ScrollToTop.js";
import { getProductCate } from "api/ProductCategoryApi.js";

const MainLandingPage        = lazy(() => import("./MainLandingPage"));
const ProductList            = lazy(() => import("./pages/ProductList.js"));
const MyScheme               = lazy(() => import("./pages/MyScheme.js"));
const About                  = lazy(() => import("./pages/About.js"));
const JoinScheme             = lazy(() => import("./pages/JoinScheme.js"));
const SchemeList             = lazy(() => import("./pages/SchemeList.js"));
const ProductDetails         = lazy(() => import("./pages/ProductDetails.js"));
const SchemeDetails          = lazy(() => import("./pages/SchemeDetails.js"));
const WishList               = lazy(() => import("./pages/WishList.js"));
const MostLiked              = lazy(() => import("./pages/MostLiked.js"));
const BookAnAppointment      = lazy(() => import("./pages/BookAnAppointment.js"));
const Offers                 = lazy(() => import("./pages/Offers"));
const NewArrivals            = lazy(() => import("./pages/NewArrivals.js"));
const CartPage               = lazy(() => import("./pages/CartPage.js"));
const CheckoutPage           = lazy(() => import("pages/CheckoutPage.js"));
const Contact                = lazy(() => import("pages/Contact.js"));
const TermsConditions        = lazy(() => import("pages/Policies/TermsConditions"));
const PrivacyPolicy          = lazy(() => import("pages/Policies/PrivacyPolicy"));
const ShippingPolicy         = lazy(() => import("pages/Policies/ShippingPolicy"));
const RefundPolicy           = lazy(() => import("pages/Policies/RefundPolicy"));
const OrderStatusPage        = lazy(() => import("pages/OrderStatusPage"));
const ReferralPoints         = lazy(() => import("pages/ReferralPoints.js"));
const ProductOrderDetails    = lazy(() => import("./pages/ProductOrderDetails.js"));
const BestSellingComponent   = lazy(() => import("components/BestSellingComponent.js"));
const TrendOnShopComponent   = lazy(() => import("components/TrendOnShopComponent.js"));
const ShopOurExclusiveComponent = lazy(() => import("components/ShopOurExclusiveComponent.js"));
const OccasionCategoriesComponent = lazy(() => import("components/OccasionCategoriesComponent.js"));
const MyPurchase             = lazy(() => import("components/MyPurchase.js"));
const AddAddress             = lazy(() => import("components/AddAddress.js"));
const ViewAddress        = lazy(() => import('./components/ViewAddress.js'));
const TechWallet             = lazy(() => import("components/TechWallet.js"));

const PageFallback = () => (
  <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
    <div style={{ width: 32, height: 32, borderRadius: "50%", border: "3px solid #f0b0b0ff", borderTopColor: "#b81f0bff", animation: "spin 0.7s linear infinite" }} />
  </div>
);

const CONFIG_IMAGES = JSON.parse(
  '{"PGIMAGES":[{"key":"paymentGatway","value":"https://images.prod-rasiinfotech.in/ecomm/paymentGatway.png"}],"STORIMAGES":[{"key":"store1","value":"https://images.prod-rasiinfotech.in/ecomm/jewelleryShop1.jpg"},{"key":"store2","value":"https://images.prod-rasiinfotech.in/ecomm/jewelleryShop2.jpg"}],"MOBILE_APP_QR":[{"key":"qrCode","value":"https://images.prod-rasiinfotech.in/ecomm/downloadApps.png"}],"E_COMMERCE_BANNERS":[{"key":"cart","value":"https://images.prod-rasiinfotech.in/ecomm/cart.png"},{"key":"enquiry","value":"https://images.prod-rasiinfotech.in/ecomm/enquiry.png"},{"key":"joinScheme","value":"https://images.prod-rasiinfotech.in/ecomm/joinScheme.png"},{"key":"mostLiked","value":"https://images.prod-rasiinfotech.in/ecomm/mostLiked.png"},{"key":"newArrivals","value":"https://images.prod-rasiinfotech.in/ecomm/newArrivals.png"},{"key":"offer","value":"https://images.prod-rasiinfotech.in/ecomm/offer.png"},{"key":"privacyPolicy","value":"https://images.prod-rasiinfotech.in/ecomm/privacyPolicy.png"},{"key":"productDetails","value":"https://images.prod-rasiinfotech.in/ecomm/productDetails.png"},{"key":"productList","value":"https://images.prod-rasiinfotech.in/ecomm/productList.png"},{"key":"refundPolicy","value":"https://images.prod-rasiinfotech.in/ecomm/refundPolicy.png"},{"key":"savingScheme","value":"https://images.prod-rasiinfotech.in/ecomm/savingScheme.png"},{"key":"schemeDetails","value":"https://images.prod-rasiinfotech.in/ecomm/schemeDetails.png"},{"key":"shippingPolicy","value":"https://images.prod-rasiinfotech.in/ecomm/shippingPolicy.png"},{"key":"termsConditions","value":"https://images.prod-rasiinfotech.in/ecomm/termsConditions.png"},{"key":"whishList","value":"https://images.prod-rasiinfotech.in/ecomm/whishList.png"},{"key":"paymentGatway","value":"https://images.prod-rasiinfotech.in/ecomm/paymentGatway.png"},{"key":"contact","value":"https://images.prod-rasiinfotech.in/ecomm/contact.png"},{"key":"referral","value":"https://images.prod-rasiinfotech.in/ecomm/whishList.png"}]}'
);

export default function App() {

  const [token, setToken] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [branch, setBranch] = useState({});
  const [prodLabel,setProdLabel] = useState({});
  const configImages = CONFIG_IMAGES;
  const { branchId } = useCartContext();
  const helmetContext = {};

  // Show button when page is scorlled upto given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    initialAuth();
    window.addEventListener("scroll", toggleVisibility, { passive: true });
    return () => window.removeEventListener("scroll", toggleVisibility);
    //eslint-disable-next-line
  }, []);

  const initialAuth = () => {
    const loginDetails = {
      username: "ONLINEPAYMENT",
      password: "Payment@123",
    };
    const responseData = login(JSON.stringify(loginDetails));
    responseData.then((data) => {
      if (
        data &&
        data.authStatus &&
        data.authStatus.toLowerCase() === "success"
      ) {
        if (data.token) {
          setBearerToken(data.token);
          setBranchId(data.empDefaultBranch);
          setToken(true);
          getProductLabels();
          branchDetails();
        }
      }
    });
  };

   useEffect(() => { 
    Promise.all([
      getProductLabels()
    ])
    .then(() => {
      branchDetails(); 
    })
    .catch(console.error())
  }, [branchId]); // eslint-disable-line

  const branchDetails = () => {
    branchdetails(getBranchId()).then((data) => {
      setBranch(data.response);
      setCorporateId(data.response.storeDetails);
    });
  };

  const getProductLabels = () => {
    const filterData = {
      visibilityMode: "BRAND"
    }
    const response = getProductCate(filterData)
    response.then(
      (data) => {
        const requiredLabel = ['BestSellers','MostLikedProducts','ShopOurExclusives','TrendOnShop','NewArrival']
        const prodLabelData = []
        data.response.content.forEach(item => {
          if (requiredLabel.includes(item.name)) {
            prodLabelData.push({
              value:item.id,
              label:item.displayName,
              name:item.name
            })
          }
        });
        setProdLabel(prodLabelData)
      }
    )
    return response
  }

  return (
    <>
      <HelmetProvider context={helmetContext}>
        {token && getHeaderConfig() ? (
          <Router>
            <ScrollToTop />
            <Header branch={branch} />
            <Suspense fallback={<PageFallback />}>
            <Routes>
              <Route path="/MyScheme"
                element={<MyScheme />}
              />
              <Route path="/ProductList"
                element={<ProductList configImages={configImages} />}
              />
              <Route path="/SchemeList"
                element={<SchemeList branch={branch} configImages={configImages} />}
              />
              <Route path="/ProductDetails/:id"
                element={<ProductDetails branch={branch} configImages={configImages} />}
              />
              <Route path="/SchemeDetails"
                element={<SchemeDetails configImages={configImages} />}
              />
              <Route path="/About"
                element={<About branch={branch} />}
              />
              <Route path="/JoinScheme"
                element={<JoinScheme configImages={configImages} />}
              />
              <Route path="/WishList"
                element={<WishList configImages={configImages} />}
              />
              <Route path="/MostLiked"
                element={<MostLiked configImages={configImages} prodLabel={prodLabel}/>}
              />
              <Route path="/NewArrivals"
                element={<NewArrivals configImages={configImages} prodLabel={prodLabel}/>}
              />
              <Route path="/BookAnAppointment"
                element={<BookAnAppointment configImages={configImages} />}
              />
              <Route path="/Offers"
                element={<Offers configImages={configImages} />}
              />
              <Route path="/CartPage"
                element={<CartPage configImages={configImages} />}
              />
              <Route path="/CheckoutPage"
                element={<CheckoutPage />}
              />
              <Route path="/Contact"
                element={<Contact configImages={configImages} />}
              />
              <Route path="/TermsConditions"
                element={<TermsConditions branch={branch} configImages={configImages} />}
              />
              <Route path="/ReferralPoints"
                element={<ReferralPoints configImages={configImages} />}
              />
              <Route path="/ProductOrderDetails"
                element={<ProductOrderDetails configImages={configImages} />}
              />
              <Route path="/PrivacyPolicy"
                element={<PrivacyPolicy branch={branch} configImages={configImages} />}
              />
              <Route path="/ShippingPolicy"
                element={<ShippingPolicy branch={branch} configImages={configImages} />}
              />
              <Route path="/RefundPolicy"
                element={<RefundPolicy branch={branch} configImages={configImages} />}
              />
              <Route path="/OrderStatusPage"
                element={<OrderStatusPage />}
              />
              {/* <Route path="/CCAvRequestHandler"
            element={ <CCAveRequest />}
            />
            <Route path="/CCAvResponseHandler">
              <CCAveResponse />
            </Route> */}
              <Route path="/BestSellingComponent"
                element={<BestSellingComponent configImages={configImages} prodLabel={prodLabel}/>}
              />
              <Route path="/TrendOnShopComponent"
                element={<TrendOnShopComponent configImages={configImages} prodLabel={prodLabel}/>}
              />
              <Route path="/ShopOurExclusiveComponent"
                element={<ShopOurExclusiveComponent configImages={configImages} prodLabel={prodLabel}/>}
              />
              <Route path="/OccasionCategoriesComponent"
                element={<OccasionCategoriesComponent configImages={configImages} />}
              />
              <Route path="/MyPurchase"
                element={<MyPurchase configImages={configImages} />}
              />
              <Route path="/AddAddress"
                element={<AddAddress configImages={configImages} />}
              />
              <Route path='/ViewAddress'
                element={<ViewAddress />}
              />
              <Route path='/TechWallet'
                element={<TechWallet configImages={configImages} branch={branch} />}
              />
              <Route path="/"
                element={<MainLandingPage prodLabel={prodLabel}/>}
              />
              <Route path="/QRCode"
                element={<QRCode  configImages={configImages}/>}
              />
            </Routes>
            </Suspense>
            <Footer branch={branch} configImages={configImages} prodLabel={prodLabel}/>
          </Router>
        ) : (
          <div className="position-absolute  top-50 start-50 translate-middle">
            <div className="loader">
              <img
                src={logo}
                className="vert-move m-auto rounded-circle p-3"
                alt="login Loader"
              />
            </div>
          </div>
        )}

        <div className="scroll-to-top position-fixed  bottom-0 end-0 m-4">
          {isVisible && (
            <div
              onClick={scrollToTop}
              className="rounded-circle hoverEffect"
              style={{ cursor: "pointer" }}
            >
              <i
                className="bi bi-arrow-up-short px-2 fs-2"
                style={{ fontSize: "20px" }}
              ></i>
            </div>
          )}
        </div>
      </HelmetProvider>
    </>
  );
}
